import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	avatarImage: {
		height       : "2.5rem",
		width        : "2.5rem",
		borderRadius : "100%",
		objectFit    : "cover",
		cursor       : "pointer"
	},
	anchorTag: {
		all: "unset"
	}

} );
